import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'
import Route from 'react-router-dom/Route';
import './App.css';
import Home from './components/Home';
import Scan from './components/Scan';
import CurrentLocation from './components/CurrentLocation';
import Destination from './components/Destination';
import NextPage from './components/NextPage'

// Redux stuff
import List from "./js/List.jsx";
// <List />
import Form from "./components/Form.jsx";
// <Form />
import Post from "./components/Posts.jsx";
// <Post />

import Map from './components/map';

class App extends Component {

  

  render() {


    return (



      <Router>
        <div className="App">

          <Route path="/" exact component={Home}/>
          <Route path="/scan" exact component={Scan}/>
          <Route path="/currentlocation" exact component={CurrentLocation}/>
          <Route path="/destination/:destination_id" exact component={Destination}/>
          <Route path="/map/:map_id" exact component={Map}/>
          <Route path="/next/:map_id" exact component={NextPage}/>

        </div>
      </Router>
    );
  }
}

export default App;
